import React, {Component} from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import {faLink} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {EDIT_MODE} from "../../../../../../wpconfig"

import * as Actions from "../../../../../../store/modules/journals";
import * as FActions from "../../../../../../store/modules/footer";
import * as func from "../../../../../../utils/functions";
import DBItem from "./item";
import IdsItem from "../../1_Ids/item";

class JournalDbRegister extends Component {
	constructor(props) {
		super(props);

		this.state = {
			inInit : false,
			isEdit: this.props.record.is_edit ? EDIT_MODE.SHOW_EDIT : EDIT_MODE.SHOW,
			category: [],
			categoryName : {},
			category2: [{code_id : 'in' , code_name : '등재'}, {code_id : 'out' , code_name : '탈락'}],
			category2Name : {'in' : '등재', 'out' : '탈락'},
			categoryType: 'register_type',
			insertRecord: null,
			editIndex : '',
			type : '',
			field : 'journal_db_register',
			pkKey : 'register_id'
		}

		this.onInsert = this.onInsert.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.onRemove = this.onRemove.bind(this);
		this.onEditIndex = this.onEditIndex.bind(this);

		this.showMessage = this.showMessage.bind(this);

		func.getData("code/search/" + this.state.categoryType, {}).then((response) => {
			const t = {type : response.records[0].code_id};
			t.inInit = true;
			t.category = response.records;
			t.categoryName = {}
			response.records.map((r, i) => {
				t.categoryName[r.code_id] = r.code_name;
			});
			this.setState(t);
		});
	}

	onInsert() {
		const record = this.props.record;

		if (record[this.state.field].length > 0 && record[this.state.field][0][this.state.pkKey] === '') {
			this.showMessage('추가해주세요.')
		} else {
			const insertRecord = {
				'register_id': '',
				'register_db_type': this.state.type,
				'register_status' : 'in',
				'register_yyyymm': '',
				'memo' : '',
				'is_edit' : true
			}
			this.onEditIndex(0);
			record[this.state.field].unshift(insertRecord);
			this.props.dataActions.setJournal({"record": record});
		}
	}

	onUpdate(index, item, render) {
		const record = this.props.record;
		record[this.state.field][index] = item;
		this.props.dataActions.setJournal({"record": record});
		if(render)
			this.forceUpdate();
	}

	onRemove(index) {
		const record = this.props.record;
		record[this.state.field].splice(index, 1);
		this.props.dataActions.setJournal({'record': record});
		this.forceUpdate();
	}

	onEditIndex(id) {
		if(this.state.editIndex)
			this.refs["ref" + this.state.editIndex].onClose();
		else if(this.refs.ref)
			this.refs.ref.onClose();
		else if(this.refs["ref" + this.state.editIndex])
			this.refs["ref" + this.state.editIndex].onClose();

		this.setState({
			'editIndex' : id
		})
	}

	showMessage(message) {
		this.props.fDataActions.setFooter({
			'isNoticePopup': true,
			'noticeMessage': message
		})
		setTimeout(() => {
			this.props.fDataActions.setFooter({
				'isNoticePopup': false,
				'noticeMessage': ''
			})
		}, 3000);
	}

	render() {
		const record = this.props.record;

		if(!this.state.inInit)
			return '';

		return (
			<>
				<div className="d-flex justify-content-end mt-4 mb-1">
					<h5 className="flex-grow-1">등재 정보</h5>
					<button type="button" className="btn btn-sm btn-outline-dark" onClick={this.onInsert}>추가</button>
				</div>
				<table className="widefat fixed striped editable journal-db-register mb-3">
					<thead>
					<tr>
						<th className="pt-2 pb-2">No</th>
						<th>등재유형</th>
						<th>등재상태</th>
						<th>날짜</th>
						<th>메모</th>
						<th>Action</th>
					</tr>
					</thead>
					<tbody>
					{record[this.state.field].map((record, index) => {
						return (
							<DBItem
								key={record[this.state.pkKey]}
								index={record[this.state.pkKey]}
								ref={"ref" + record[this.state.pkKey]}
								pkKey={this.state.pkKey}
								arrIndex={index}
								record={record}
								category={this.state.category}
								categoryName={this.state.categoryName}
								category2={this.state.category2}
								category2Name={this.state.category2Name}
								onEditIndex={this.onEditIndex}
								onUpdate={this.onUpdate}
								onRemove={this.onRemove}
								showMessage={this.showMessage}
							/>
						)
					})}
					</tbody>
				</table>
			</>
		)
	}
}

export default connect(
	(state) => ({
		record: state.journals.record ? state.journals.record : {},
		meta: state.journals.meta ? state.journals.meta : {},
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch),
		fDataActions: bindActionCreators(FActions, dispatch)
	}),
)(JournalDbRegister)
